/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Audio_Embed_Export_Progress_CompleteInputs */



/**
* | output |
* | --- |
* | "Embed complete!" |
*
* @param {Audio_Embed_Export_Progress_CompleteInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const audio_embed_export_progress_complete = /** @type {((inputs?: Audio_Embed_Export_Progress_CompleteInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Audio_Embed_Export_Progress_CompleteInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Intégration terminée !")
	if (locale === "de") return /** @type {LocalizedString} */ ("Einbettung abgeschlossen!")
	if (locale === "it") return /** @type {LocalizedString} */ ("Incorporamento completato!")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Вставка завершена!")
	if (locale === "es") return /** @type {LocalizedString} */ ("¡Inserción completada!")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("嵌入完成！")
	if (locale === "ja") return /** @type {LocalizedString} */ ("埋め込み完了！")
	if (locale === "hi") return /** @type {LocalizedString} */ ("एम्बेड पूरा हुआ!")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Incorporação concluída!")
	return /** @type {LocalizedString} */ ("Embed complete!")
});